/* global jQuery, alert, DOMParser */

import { Module } from 'wrapper6'
import 'tippy.js/themes/light.css'
import Swiper from 'swiper/bundle'
import { mttAjax } from 'utils/_mtt_ajax'
const tippy = require('tippy.js').default

export default class CheckboxVariations extends Module {
  ready () {
    this.variationsForm = document.getElementsByClassName('variations_form')[0]
    if (!this.variationsForm) return

    this.radioButtons = this.variationsForm.querySelectorAll("input[type='radio']")
    this.attributes = []
    this.lowProductStockAmount = this.variationsForm.dataset.low_stock_amount
    this.variantObjects = JSON.parse(this.variationsForm.dataset.product_variations)
    this.variantPrices = JSON.parse(this.variationsForm.dataset.variations_prices)
    this.priceHtmlTemplate = this.variationsForm.dataset.price_html
    this.minimumQuantity = parseInt(this.variationsForm.dataset.minimum_quantity)
    this.language = this.variationsForm.dataset.language
    this.availableVariantObjects = []
    this.availableOutOfStockVariantObjects = []
    this.button = document.querySelector('.single_add_to_cart_button')
    this.productId = this.variationsForm.dataset.product_id
    this.variantId = 0
    this.priceHtml = this.variationsForm.getElementsByClassName('woocommerce-variation single_variation')[0]
    this.perMeterInput = this.variationsForm.querySelector('#mtt-amount-per-meter-field')
    this.quantityInput = this.variationsForm.querySelector('input[name="quantity"]')
    this.hedgePlants = this.variationsForm.querySelectorAll('input[name="hedge-plant"]')
    this.hedgePlantPostal = this.variationsForm.querySelector('input[name="postal"]')
    this.hedgePlantPrice = this.variationsForm.querySelector('input[name="hedge-plant-price"]')
    this.hedgePlantPricetimeout = ''
    this.consultingVisit = this.variationsForm.querySelector('input[name="consulting-visit"]')
    this.selectedAttributes = {}
    this.tooltipObject = JSON.parse(this.variationsForm.dataset.tooltip)
    this.productGalleryWrap = document.querySelector('.mtt-product-gallery__image-wrap')
    this.productGalleryImages = document.querySelectorAll('.mtt-product-gallery__image-wrap img')
    this.overlay = document.getElementById('cart-overlay')

    // setup initial images
    this.initialImages = []
    if (this.productGalleryImages.length > 0) {
      for (let i = 0; i < this.productGalleryImages.length; i++) {
        this.initialImages.push(this.productGalleryImages[i].getAttribute('src'))
      }
    }

    this.body = document.getElementsByTagName('body')[0]
    this.header = document.getElementsByClassName('mtt-header')[0]
    this.miniCart = document.getElementsByClassName('menu-mini-cart')[0]

    this.initProductFadeSwiper()
    this.setup()
  }

  setup () {
    const attributeDomNodes = this.variationsForm.getElementsByClassName('mtt-variations')

    for (let i = 0; i < attributeDomNodes.length; i++) {
      this.attributes.push(attributeDomNodes[i].dataset.attribute)
    }

    for (let i = 0; i < this.radioButtons.length; i++) {
      if (this.radioButtons[i].name === 'hedge-plant') continue
      this.radioButtons[i].addEventListener('click', (e) => {
        this.handleClick()
        this.checkVariationsExists()
        this.checkVariationStock()
        this.checkLowVariationStock()
      })
    }

    if (this.quantityInput) {
      this.quantityInput.addEventListener('input', () => {
        this.handleClick()
        this.checkVariationStock()

        for (let i = 0; i < this.hedgePlants.length; i++) {
          if (!this.hedgePlants[i].checked || this.hedgePlants[i].value === 'false') continue
          this.handlePlantingPrice()
          break
        }
      })
    }

    if (this.button) {
      this.button.addEventListener('click', async () => {
        if (this.button.classList.contains('wc-variation-selection-needed')) {
          return
        }

        await this.addToCart()
      })
    }

    if (this.perMeterInput) {
      this.perMeterInput.addEventListener('input', () => {
        this.handlePerMeterClick()
        this.handleClick()
        this.checkVariationStock()
        this.updateSuffix(this.quantityInput, this.variationsForm.querySelector('.postfix'))

        for (let i = 0; i < this.hedgePlants.length; i++) {
          if (!this.hedgePlants[i].checked || this.hedgePlants[i].value === 'false') continue
          this.handlePlantingPrice()
          break
        }
      })
    }

    if (this.hedgePlantPostal) {
      this.hedgePlantPostal.addEventListener('input', () => {
        this.handlePlantingPrice()
      })
    }

    this.setupPostfix()
    this.checkVariationsStockStatus()
    this.stopWCHidePrice()
    this.handleClick()
    this.checkVariationsExists()
    this.checkLowVariationStock()
  }

  setupPostfix () {
    this.updateSuffix(this.quantityInput, this.variationsForm.querySelector('.postfix'))
    this.variationsForm.querySelector('.postfix').hidden = false
  }

  /**
   * Add to cart handler.
   * This is triggered when clicked on the "Add to cart" button.
   *
   * @returns {Promise<void>}
   */
  async addToCart () {
    this.button.classList.add('loading')

    let hedgePlantValue = 'false'
    for (let i = 0; i < this.hedgePlants.length; i++) {
      if (!this.hedgePlants[i].checked) continue
      hedgePlantValue = this.hedgePlants[i].value
      break
    }

    const data = {
      action: 'add_variable_product_to_cart',
      product_id: this.productId,
      variant_id: this.variantId,
      quantity: this.quantityInput.value,
      hedge_plant: hedgePlantValue,
      hedge_plant_postal: this.hedgePlantPostal ? this.hedgePlantPostal.value : undefined,
      consulting_visit: this.consultingVisit ? this.consultingVisit.checked : undefined
    }

    mttAjax('add_variable_product_to_cart', data, this.callbackAddToCart.bind(this))
  }

  callbackAddToCart (response) {
    this.button.classList.remove('loading')
    if (typeof response !== 'object' || response === null) return console.warn('Response is not a object!')
    if (response.success === true) {
      const miniCartHtml = new DOMParser().parseFromString(response.data.mini_cart_html, 'text/html')
      document.querySelector('.menu-mini-cart').innerHTML = miniCartHtml.querySelector('.menu-mini-cart').innerHTML
      document.querySelector('body').classList.add('mini-cart-open')
      document.querySelector('html').classList.add('mini-cart-open')

      this.handleCartCount(response.data.cart_count)

      this.body.classList.add('header-scrolled')
      this.header.classList.add('mtt-header--scrolled')
      this.miniCart.classList.remove('closed')
      this.overlay.classList.add('show')
      this.miniCart.classList.remove('empty')

      const showDidYouMissPopup = this.variationsForm.querySelector('input[name="show-did-you-miss-popup"]')
      if (showDidYouMissPopup && showDidYouMissPopup.value === 'true') openModal(document.getElementById('did-you-miss-popup'))
      return
    }
    alert('Det valgte antal er desværre ikke muligt at bestille. Kontakt os gerne hvis der er yderlige spørgsmål.')
  }

  /**
   * Check all variation if the are in stock.
   */
  checkVariationsStockStatus () {
    const variationsInStock = []
    const variationsOutOfStock = []
    for (let i = 0; i < this.variantObjects.length; i++) {
      if (this.variantObjects[i].is_in_stock === true && this.variantObjects[i].max_qty !== 0 && this.variantObjects[i].max_qty) {
        variationsInStock.push(this.variantObjects[i])
      } else {
        variationsOutOfStock.push(this.variantObjects[i])
      }
    }
    this.availableVariantObjects = variationsInStock
    this.availableOutOfStockVariantObjects = variationsOutOfStock
  }

  /**
   * Loops through all radio buttons, to get if there is a variation with the combination.
   * Either disabled a field or activates a field.
   */
  checkVariationsExists () {
    const variationsCombinations = this.getVariationsCombinations()
    const outOfStockVariationsCombinations = this.getOutOfStockVariationsCombinations()
    const tempSelectedAttributes = Object.assign({}, this.selectedAttributes)
    if (Object.keys(this.selectedAttributes).length > 1) delete tempSelectedAttributes[Object.keys(this.selectedAttributes)[Object.keys(this.selectedAttributes).length - 1]]

    for (let i = 0; i < this.radioButtons.length; i++) {
      this.radioButtons[i].parentElement.style.display = ''
      if (this.radioButtons[i].name === 'hedge-plant') continue
      if (Object.keys(variationsCombinations).length === 0 && Object.keys(outOfStockVariationsCombinations).length === 0 && !Object.keys(tempSelectedAttributes).includes(this.radioButtons[i].name)) {
        this.radioButtons[i].parentElement.querySelector('span').classList.add('disabled')
        this.radioButtons[i].disabled = true
        continue
      }
      if (Object.keys(variationsCombinations).length === 0) this.checkVariationsExistsOutOfStock(i, outOfStockVariationsCombinations)
      for (let j = 0; j < Object.keys(variationsCombinations).length; j++) {
        if (this.radioButtons[i].name !== Object.keys(variationsCombinations)[j]) break
        if (Object.keys(outOfStockVariationsCombinations).length !== 0) {
          if (Object.values(outOfStockVariationsCombinations)[j].includes(this.radioButtons[i].value)) {
            this.radioButtons[i].parentElement.querySelector('span').classList.add('disabled')
            this.radioButtons[i].disabled = true
            this.radioButtons[i].parentElement.style.display = ''
            continue
          } else {
            this.radioButtons[i].parentElement.querySelector('span').classList.remove('disabled')
            this.radioButtons[i].removeAttribute('disabled')
          }
        } else {
          this.radioButtons[i].parentElement.querySelector('span').classList.remove('disabled')
          this.radioButtons[i].removeAttribute('disabled')
        }
        if (Object.values(variationsCombinations)[j].includes(this.radioButtons[i].value)) {
          this.radioButtons[i].parentElement.style.display = ''
          continue
        }
        this.radioButtons[i].parentElement.style.display = 'none'
      }
    }
  }

  checkVariationsExistsOutOfStock (i, outOfStockVariationsCombinations) {
    for (let j = 0; j < Object.keys(outOfStockVariationsCombinations).length; j++) {
      if (this.radioButtons[i].name !== Object.keys(outOfStockVariationsCombinations)[j]) break
      this.radioButtons[i].parentElement.querySelector('span').classList.add('disabled')
      this.radioButtons[i].disabled = true
      if (Object.values(outOfStockVariationsCombinations)[j].includes(this.radioButtons[i].value)) {
        this.radioButtons[i].parentElement.style.display = ''
        continue
      }
      this.radioButtons[i].parentElement.style.display = 'none'
    }
  }

  getVariationsCombinations () {
    const variationObject = {}
    for (let i = 0; i < this.availableVariantObjects.length; i++) {
      if (Object.keys(this.availableVariantObjects[i].attributes).length === 1) {
        if (variationObject[Object.keys(this.selectedAttributes)[0]] === undefined) {
          variationObject[Object.keys(this.selectedAttributes)[0]] = []
        }
        variationObject[Object.keys(this.selectedAttributes)[0]].push(Object.values(this.availableVariantObjects[i].attributes)[0])
      }
      for (let j = 0; j < Object.keys(this.availableVariantObjects[i].attributes).length; j++) {
        if (Object.values(this.selectedAttributes)[0] !== Object.values(this.availableVariantObjects[i].attributes)[0]) break
        if (j === 0) continue
        if (variationObject[Object.keys(this.selectedAttributes)[j]] === undefined) {
          variationObject[Object.keys(this.selectedAttributes)[j]] = []
        }
        variationObject[Object.keys(this.selectedAttributes)[j]].push(Object.values(this.availableVariantObjects[i].attributes)[j])
      }
    }

    return variationObject
  }

  getOutOfStockVariationsCombinations () {
    const outOfStockVariationObject = {}
    for (let i = 0; i < this.availableOutOfStockVariantObjects.length; i++) {
      if (Object.keys(this.availableOutOfStockVariantObjects[i].attributes).length === 1) {
        if (outOfStockVariationObject[Object.keys(this.selectedAttributes)[0]] === undefined) {
          outOfStockVariationObject[Object.keys(this.selectedAttributes)[0]] = []
        }
        outOfStockVariationObject[Object.keys(this.selectedAttributes)[0]].push(Object.values(this.availableOutOfStockVariantObjects[i].attributes)[0])
      }
      for (let j = 0; j < Object.keys(this.availableOutOfStockVariantObjects[i].attributes).length; j++) {
        if (Object.values(this.selectedAttributes)[0] !== Object.values(this.availableOutOfStockVariantObjects[i].attributes)[0]) break
        if (j === 0) continue
        if (outOfStockVariationObject[Object.keys(this.selectedAttributes)[j]] === undefined) {
          outOfStockVariationObject[Object.keys(this.selectedAttributes)[j]] = []
        }
        outOfStockVariationObject[Object.keys(this.selectedAttributes)[j]].push(Object.values(this.availableOutOfStockVariantObjects[i].attributes)[j])
      }
    }

    return outOfStockVariationObject
  }

  /**
   * This will take the last attribute of the first available variation combination and select that field.
   */
  selectFirstVariant () {
    const variationsCombinations = this.getVariationsCombinations()
    const tempSelectedAttributes = Object.assign({}, this.selectedAttributes)
    const lastAttributeKey = Object.keys(this.selectedAttributes)[Object.keys(this.selectedAttributes).length - 1]
    if (Object.keys(this.selectedAttributes).length > 1) delete tempSelectedAttributes[lastAttributeKey]

    if (Object.values(variationsCombinations).length === 0) return
    for (let i = 0; i < this.radioButtons.length; i++) {
      if (this.radioButtons[i].name !== lastAttributeKey) continue
      if (this.radioButtons[i].value !== Object.values(variationsCombinations[lastAttributeKey])[0]) continue

      this.radioButtons[i].checked = true
    }
  }

  /**
   * Handle when a radio button is changed.
   * It check what the values is for the selected radio buttons and then check if there is a variation that matches.
   */
  handleClick () {
    const selected = []

    if (this.radioButtons.length > 0) {
      for (let i = 0; i < this.radioButtons.length; i++) {
        if (this.radioButtons[i].name === 'hedge-plant') continue
        const radioButton = this.radioButtons[i]
        if (radioButton.checked) {
          selected.push(radioButton)
          this.selectedAttributes[radioButton.name] = radioButton.value
        }
      }
    }

    this.disabledAddToCartButton()
    if (selected.length === Object.keys(this.selectedAttributes).length) {
      const match = this.matchVariant(selected)

      if (this.minimumQuantity > parseInt(this.quantityInput.value)) {
        this.disabledAddToCartButton()
        return
      }

      if (match !== false) {
        // PER METER CALCULATOR
        const width = match.dimensions.width // Width in CM
        let perMeter = 100 / width
        if (width == 33) perMeter = Math.round(perMeter)
        if (perMeter % 1 !== 0) perMeter = perMeter.toFixed(2)
        jQuery('#mtt-amount-per-meter-field').attr('data-per-meter', perMeter)
        this.handlePerMeterClick()
        jQuery('.mtt-amount-calculator .per-meter').html(perMeter) // TODO: DK numberformatting

        this.variantId = match.variation_id
        this.priceHtml.innerHTML = ''
        jQuery(this.priceHtml).append(this.handlePriceFormat(this.handlePrice(match.variation_id, parseInt(this.quantityInput.value)) * parseInt(this.quantityInput.value)))
        this.priceHtml.style.display = 'block'

        const singlePrice = this.handlePrice(match.variation_id, parseInt(this.quantityInput.value))
        jQuery('#mtt-single-price').html(singlePrice)

        // change image based on variation image
        if (this.productGalleryWrap && match.mtt_images !== '') {
          if (this.productGalleryImages.length > 0) {
            for (let i = 0; i < this.productGalleryImages.length; i++) {
              const IMAGE = this.productGalleryImages[i]
              IMAGE.removeAttribute('srcset')
              if (match.mtt_images[i] !== null) {
                IMAGE.setAttribute('src', match.mtt_images[i][0])
                !this.SWIPER.autoplay.running && this.SWIPER.autoplay.start()
              } else {
                IMAGE.setAttribute('src', this.initialImages[i])
                this.SWIPER.slideTo(0)
                this.SWIPER.autoplay.running && this.SWIPER.autoplay.stop()
              }
            }
          }
        }

        this.activateAddToCartButton()
      } else {
        this.variantId = undefined
        this.disabledAddToCartButton()
        if (Object.values(this.getVariationsCombinations()).length !== 0) {
          this.selectFirstVariant()
          this.handleClick()
        }
      }
    }
  }

  handlePriceFormat (price) {
    const priceDocument = jQuery(jQuery.parseHTML(this.priceHtmlTemplate)[0])
    const currency = priceDocument.find('.woocommerce-Price-currencySymbol')
    priceDocument.find('bdi').html(price + ' ' + currency.html())
    return priceDocument.get(0)
  }

  handlePrice (variationId, quantity) {
    if (typeof this.variantPrices[variationId] !== 'object') return this.variantPrices[variationId]

    if (this.language === 'da') {
      if (quantity === 1) return this.variantPrices[variationId].one_to_one
      if (quantity === 2) return this.variantPrices[variationId].two_to_two
      if (quantity === 3) return this.variantPrices[variationId].three_to_three
      if (quantity >= 4 && quantity <= 5) return this.variantPrices[variationId].four_to_five
      if (quantity >= 6 && quantity <= 9) return this.variantPrices[variationId].six_to_nine
      if (quantity >= 10 && quantity <= 13) return this.variantPrices[variationId].ten_to_thirteen
      if (quantity >= 14 && quantity <= 19) return this.variantPrices[variationId].fourteen_to_nineteen
      if (quantity >= 20 && quantity <= 59) return this.variantPrices[variationId]['20_to_59']
      if (quantity >= 60 && quantity <= 119) return this.variantPrices[variationId]['60_to_119']
      if (quantity >= 120) return this.variantPrices[variationId]['120_to_999']
    }
    if (this.language === 'no') {
      if (quantity >= 10 && quantity <= 19) return this.variantPrices[variationId].ten_to_nineteen
      if (quantity >= 20 && quantity <= 59) return this.variantPrices[variationId]['20_to_59']
      if (quantity >= 60 && quantity <= 119) return this.variantPrices[variationId]['60_to_119']
      if (quantity >= 120) return this.variantPrices[variationId]['120_to_999']
      return 0
    }
    if (this.language === 'sv') {
      if (quantity <= 59) return this.variantPrices[variationId].three_to_59
      if (quantity >= 60 && quantity <= 119) return this.variantPrices[variationId]['60_to_119']
      if (quantity >= 120) return this.variantPrices[variationId]['120_to_999']
      return 0
    }

    return ''
  }

  initProductFadeSwiper () {
    if (this.productGalleryWrap) {
      this.SWIPER = new Swiper(this.productGalleryWrap, {
        slidesPerView: 1,
        speed: 1000,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: { delay: 6000 },
        simulateTouch: false
      })
    }
  }

  /**
   * Loops though all the available variations and check if there is one that matches the selected values.
   *
   * @param selected
   * @returns {boolean|*}
   */
  matchVariant (selected) {
    const currentVariations = Object.assign({}, this.availableVariantObjects)
    for (let i = 0; i < this.availableVariantObjects.length; i++) {
      let notFoundAttribute = false
      for (let j = 0; j < selected.length; j++) {
        if (this.availableVariantObjects[i].attributes[selected[j].name] !== selected[j].value) notFoundAttribute = true
      }
      if (notFoundAttribute) delete currentVariations[i]
    }

    if (Object.keys(currentVariations).length > 0) return this.availableVariantObjects[Object.keys(currentVariations)[0]]
    return false
  }

  /**
   * Handle the per meter input.
   */
  handlePerMeterClick () {
    if (this.perMeterInput.value) this.quantityInput.value = Math.ceil(this.perMeterInput.value * this.perMeterInput.dataset.perMeter)
  }

  /**
   * Get the planting price for a specific zip code.
   */
  handlePlantingPrice () {
    clearInterval(this.hedgePlantPricetimeout)
    clearTimeout(this.hedgePlantPricetimeout)
    this.hedgePlantPricetimeout = setTimeout(() => {
      this.hedgePlantPrice.classList.add('loading')
      this.hedgePlantPrice.value = ''
      this.consultingVisit.setAttribute('disabled', 'disabled')
      this.consultingVisit.parentElement.querySelector('.price').innerHTML = ''

      const data = {
        action: 'get_planting_price',
        variant_id: this.variantId,
        quantity: this.quantityInput.value,
        hedge_plant_postal: this.hedgePlantPostal.value
      }

      mttAjax('get_planting_price', data, this.callbackPlantingPrice.bind(this))
    }, 1000)
  }

  callbackPlantingPrice (response) {
    this.hedgePlantPrice.classList.remove('loading')
    if (typeof response !== 'object' || response === null) return console.warn('Response is not a object!')
    if (response.success) {
      this.hedgePlantPrice.value = response.data.planting_price
      this.consultingVisit.removeAttribute('disabled', 'disabled')
      this.consultingVisit.parentElement.querySelector('.price').innerHTML = '(' + response.data.consultant_visit_price + ')'
    }
  }

  /**
   * Check if the stock of a variation is lower than the value that the customer has written in the quantity input.
   */
  checkVariationStock () {
    for (let i = 0; i < this.availableVariantObjects.length; i++) {
      if (this.availableVariantObjects[i].variation_id !== this.variantId) continue
      if (this.availableVariantObjects[i].max_qty < this.quantityInput.value || parseInt(this.minimumQuantity) > parseInt(this.quantityInput.value)) {
        this.disabledAddToCartButton()
        return
      }

      this.activateAddToCartButton()
    }
  }

  /**
   * Check if the variation stock is low. It will add a indicator if the stock is lower than the defined limit.
   */
  checkLowVariationStock () {
    const tempSelectedAttributes = Object.assign({}, this.selectedAttributes)
    delete tempSelectedAttributes[Object.keys(this.selectedAttributes)[Object.keys(this.selectedAttributes).length - 1]]
    for (let i = 0; i < this.radioButtons.length; i++) {
      if (this.radioButtons[i].name === 'hedge-plant') continue
      if (Object.keys(tempSelectedAttributes).includes(this.radioButtons[i].name)) continue
      const tempObject = {}
      tempObject[this.radioButtons[i].name] = this.radioButtons[i].value
      const indicatorElement = this.radioButtons[i].parentElement.querySelector('span').querySelector('span.low_stock')
      const index = this.checkIfVariantExistByLastParameter(tempSelectedAttributes, tempObject)
      if (index !== false) {
        let lowStock = this.lowProductStockAmount
        if (this.availableVariantObjects[index].variable_stock_limit) lowStock = parseInt(this.availableVariantObjects[index].variable_stock_limit)
        if (this.availableVariantObjects[index].max_qty <= lowStock) {
          if (indicatorElement) this.radioButtons[i].parentElement.querySelector('span').removeChild(this.radioButtons[i].parentElement.querySelector('span').querySelector('span.low_stock'))
          this.radioButtons[i].parentElement.querySelector('span').innerHTML += ' <span id="t-' + i + '" id="t-' + i + '" class="low_stock">!</span>'
          tippy('#t-' + i, {
            content: this.generateTooltipElement(this.availableVariantObjects[index].max_qty),
            allowHTML: true,
            theme: 'light',
            placement: 'bottom'
          })
          continue
        }
      }

      if (!indicatorElement) continue
      this.radioButtons[i].parentElement.querySelector('span').removeChild(this.radioButtons[i].parentElement.querySelector('span').querySelector('span.low_stock'))
    }
  }

  /**
   * Returns the attributes for all available variants.
   *
   * @returns {[]}
   */
  getAvailableVariantsAttributes () {
    const variantsAttributes = []
    for (let i = 0; i < this.availableVariantObjects.length; i++) {
      variantsAttributes.push(this.availableVariantObjects[i].attributes)
    }

    return variantsAttributes
  }

  /**
   * Check if variant exists by last attribute.
   *
   * @param unusedParameters
   * @param paramater
   * @returns {boolean|number}
   */
  checkIfVariantExistByLastParameter (unusedParameters, paramater) {
    const availableVariants = this.getAvailableVariantsAttributes()
    for (let i = 0; i < availableVariants.length; i++) {
      if (unusedParameters && Object.keys(unusedParameters).length === 0) {
        if (Object.values(paramater)[0] !== availableVariants[i][Object.keys(paramater)[0]]) continue
        return i
      } else {
        for (let j = 0; j < Object.keys(unusedParameters).length; j++) {
          if (Object.values(unusedParameters)[j] !== availableVariants[i][Object.keys(unusedParameters)[j]]) break
          if (Object.values(paramater)[0] !== availableVariants[i][Object.keys(paramater)[0]]) break
          return i
        }
      }
    }
    return false
  }

  generateTooltipElement (amount) {
    const tooltipDocument = new DOMParser().parseFromString(this.tooltipObject.tooltip, 'text/html')
    const tooltipHtml = tooltipDocument.querySelector('.tooltip-low-stock')
    tooltipHtml.querySelector('.amount').innerHTML = amount
    return tooltipHtml
  }

  /**
   * Add classes to the "Add to cart" button
   */
  disabledAddToCartButton () {
    this.button.classList.add('disabled')
    this.button.classList.add('wc-variation-selection-needed')
  }

  /**
   * Removes classes to the "Add to cart" button
   */
  activateAddToCartButton () {
    this.button.classList.remove('disabled')
    this.button.classList.remove('wc-variation-selection-needed')
  }

  /**
   * Stops WooCommerce in hiding the price element.
   */
  stopWCHidePrice () {
    jQuery(document).on('hide_variation', () => {
      jQuery('.woocommerce-variation.single_variation').stop().show()
    })

    jQuery(document).on('hide_variation', () => {
      this.button.classList.remove('disabled')
      this.button.classList.remove('wc-variation-selection-needed')
      this.handleClick()
    })
  }

  debounce (func, wait, immediate) {
    let timeout

    return function () {
      const context = this
      const args = arguments

      const later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }

      const callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)

      if (callNow) func.apply(context, args)
    }
  }

  updateSuffix (input, postfix) {
    const width = this.getTextWidth(input.value, '15px "canada-type-gibson", sans-serif')
    postfix.style.left = (width + 15) + 'px'
  }

  /**
   * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
   *
   * @param {String} text The text to be rendered.
   * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
   *
   * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
   */
  getTextWidth (text, font) {
    // re-use canvas object for better performance
    const canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'))
    const context = canvas.getContext('2d')
    context.font = font
    const metrics = context.measureText(text)
    return metrics.width
  }

  handleCartCount (count) {
    const CART_ITEM = document.querySelector('.mtt-header__main-nav-icon-link.mtt-open-cart .count')
    if (CART_ITEM) {
      CART_ITEM.innerHTML = count
    }
  }
}
